export default "__VITE_ASSET__dRSTHKMt__"